module.exports = Object.freeze({
  // 汎用メッセージ
  I0001_JP: '検索処理が正常に完了しました。',
  I0001_EN: 'Finished getting all {0} data successfully.',
  I0002_JP: '登録処理が正常に完了しました。',
  I0002_EN: 'Created {0} data successfully.',
  I0003_JP: '更新処理が正常に完了しました。',
  I0003_EN: 'Updated {0} data successfully.',
  I0004_JP: '削除処理が正常に完了しました。',
  I0004_EN: 'Deleted {0} data successfully.',
  I0005_JP: '削除対象の{0}について、得意技術からも削除を実施しました。',
  I0005_EN: 'Regarding {0} to be deleted, we also deleted it from our specialty technology. ',
  I0006_JP: '{0}の作成処理が正常に完了しました。',
  I0006_EN: 'The process of creating {0} has completed successfully.',

  // エラーメッセージ
  // 0001～4999 汎用エラー
  E0001_JP: '{0}情報の検索処理で例外が発生しました。',
  E0001_EN: 'Exception occurred during the GET of the {0}.',
  E0002_JP: '{0}情報の登録処理で例外が発生しました。',
  E0002_EN: 'Exception occurred during the POST of the {0}.',
  E0003_JP: '{0}情報の更新処理で例外が発生しました。',
  E0003_EN: 'Exception occurred during the PUT of the {0}.',
  E0004_JP: '{0}情報の削除処理で例外が発生しました。',
  E0004_EN: 'Exception occurred during the DELETE of the {0}.',
  E0005_JP: '{0}の作成処理で例外が発生しました。',
  E0005_EN: 'Exception occurred during the CREATE of the {0}.',
  E0006_JP: '{0}情報の取得処理で例外が発生しました。',
  E0006_EN: 'Exception occurred during the GET of the {0}.',

  // 5000～7999 DBエラー
  E5000_JP: '{0}情報のDB検索処理で例外が発生しました。',
  E5000_EN: 'Exception occurred DB processing in during the GET of the {0}.',
  E5001_JP: '{0}情報のDB登録処理で例外が発生しました。',
  E5001_EN: 'Exception occurred DB processing in during the POST of the {0}.',
  E5002_JP: '{0}情報のDB更新処理で例外が発生しました。',
  E5002_EN: 'Exception occurred DB processing in during the PUT of the {0}.',
  E5003_JP: '{0}情報のDB削除処理で例外が発生しました。',
  E5003_EN: 'Exception occurred DB processing in during the DELETE of the {0}.',
  E5004_JP: '{0}の検証中にDB処理で例外が発生しました。',
  E5004_EN: 'Exception occurred DB processing in during the validate of the {0}.',

  // 8000～9999 検証エラー
  E8000_JP: '{0}に値が含まれていません。（入力値：{1}）',
  E8000_EN: '{0} does not contain a value.（Input value：{1}）',
  E8001_JP: '{0}のデータ型が正しくありません。（入力値：{1}）',
  E8001_EN: 'The data type of {0} is incorrect.（Input value：{1}）',
  E8002_JP: '{0}は正しい日付書式ではありません。(入力値 : {1})',
  E8002_EN: '{0} is not the correct date format.(Input value : {1})',
  E8003_JP: '{0}は選択候補に存在しません。(入力値 : {1})',
  E8003_EN: '{0} does not exist in the selection candidates.(Input value : {1})',
  E8004_JP: '対象のデータがテーブルに存在しません。',
  E8004_EN: 'The target data does not exist in the table.',
  E8005_JP: '{0}は{1}個までしか選択出来ません。（入力値：{2}）',
  E8005_EN: '{0} can only select up to {1}.（Input value：{2}）',
  E8006_JP: '{0}が一致しません。（入力値：{1}, {2}）',
  E8006_EN: '{0} does not match.（Input value：{1}, {2}）',
  E8007_JP: '{0}に既に存在するデータは登録できません',
  E8007_EN: 'Data that already exists in {0} cannot be registered.',
  E8008_JP: 'ユーザーID、枝番が一致しません。（ユーザID：{0}, {1}、枝番：{2}, {3}）',
  E8008_EN: 'The user ID and branch number do not match.（user ID：{0}, {1}、branch number：{2}, {3}）',
  E8009_JP: '削除対象のデータは{0}にて使用されているため削除できません。{0}からの削除後、改めて削除をしてください。',
  E8009_EN: 'The data to be deleted cannot be deleted beacause it is used in {0}. After deleting the data from {0}, please delete it again.',
});